KMVP.page = {

    initPageEvents: function () {
        document.onkeydown = function (e) {
            var k = e.keyCode;
            var tags = 'input,textarea';
            var focusedTag = {};

            // prevent browser (esp. firefox) to scroll right on pressing
            // right arrow key
            if ($(':focus').length > 0) {
                focusedTag = $(':focus');
            } else {
                focusedTag = $('body');
            }
            var focusedTagName = focusedTag.prop('tagName').toLowerCase();

            if (k == 39 && tags.indexOf(focusedTagName) === -1) {
                return false;
            }
        }

        $('.js-redirect-prg-link-form').on('click', function () {
            $(this).submit();
        });

    }
};

$(document).ready(function () {
    KMVP.page.initPageEvents();
    KMVP.browserUpdatePopup.initialize();
});

$(document).ready(function () {
    $('[data-row-indicator=""]').closest('.option-row-wrapper').prev('.amount-row-table').addClass('hasBorder');
    $('[data-row-indicator=""]').closest('.option-row-wrapper').prev('.amount-row').addClass('hasBorder');
});

$(document).ready(function () {
    var parametersMap = {};
    var parameters = [];
    var paramName = '';
    var paramValue = '';

    $('a').each(function (index) {

        var href = $(this).attr('href') || '';
        parameters = href.split(/\?|&/);

        if (parameters.length > 1) {

            for (var i = 1; i < parameters.length; i++) {
                paramName = parameters[i].split('=')[0];
                paramValue = parameters[i].split('=')[1];
                parametersMap[paramName] = paramValue;
            }

            if (parametersMap.target) {
                $(this).attr('target', parametersMap.target);
            }
        }

        parametersMap = {};
        parameters = [];
        paramName = '';
        paramValue = '';
    });
});

// localize datepicker
$(document).ready(function () {
    // find the closest available datepicker language mapping to the current isocode
    // called recursive by stepwise ommiting region code first, country code second,
    // use default en-GB when no mapping os found
    function mapDatepickerIsocode(isocode) {
        if ($.inArray(isocode, Object.keys($.datepicker.regional)) >= 0) {
            return isocode;
        } else {
            var aCodes = isocode.split('-');
            if (aCodes.length <= 1) {
                return 'en-GB';
            } else {
                aCodes.pop();
                return mapDatepickerIsocode(aCodes.join("-"));
            }
        }
    }

    var isocode = mapDatepickerIsocode(KMVP.languageisocode.replace('_', '-'));
    $.datepicker.setDefaults($.datepicker.regional[isocode]);
});

$( function() {
    $.widget( "custom.iconselectmenu", $.ui.selectmenu, {
        _renderItem: function( ul, item ) {
            var li = $( "<li>" ),
                wrapper = $( "<div>", { text: item.label } );

            if (item.disabled) {
                li.addClass("ui-state-disabled");
            }

            $("<span>", {
                style: item.element.attr("data-style"),
                "class": "ui-icon " + item.element.attr("data-class")
            })
                .appendTo(wrapper);

            return li.append(wrapper).appendTo(ul);
        }
    });

    $(".product-filter-element-select").iconselectmenu({
        select: function (event, ui) {
            $(this).iconselectmenu("widget").children(":first").removeClass().addClass(ui.item.element.data("class"));
        },
        create:function(event, ui){
            $(this).iconselectmenu("widget").prepend("<i class='fa fa-angle-down'> </i>");
            $(this).iconselectmenu("widget").attr("class", $(this).children(":first").data("class"));
        }
    }).iconselectmenu("menuWidget").addClass("ui-menu-icons customicons");
} );

$(document).on('click', '.js-language-switch [data-language]', function () {
    var $this = $(this);
    var aUrlSplit = window.location.href.split('/');
    var langIdx = 3;
    if(aUrlSplit[3] === 'v1' || aUrlSplit[3] === 'v2') {
        langIdx = 4;
    }
    aUrlSplit[langIdx] = $this.data('language');
    window.location.href = aUrlSplit.join('/')
});
